export default __webpack_public_path__ + "static/media/tree.12dda5e9.svg";